const OPEN_AUDITIONS_LAST_VIEWED_KEY = 'filmini_open_auditions_last_viewed_at';
const OPEN_AUDITIONS_VIEWED_EVENT = 'filmini:open-auditions-viewed';

export interface OpenAuditionListItem {
  created_at?: string | null;
}

const parseTimestamp = (value?: string | null) => {
  if (!value) return 0;
  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) ? timestamp : 0;
};

export const getOpenAuditionsLastViewedAt = () => {
  if (typeof window === 'undefined') return 0;
  try {
    return parseTimestamp(localStorage.getItem(OPEN_AUDITIONS_LAST_VIEWED_KEY));
  } catch {
    return 0;
  }
};

export const getLatestOpenAuditionTimestamp = (auditions: OpenAuditionListItem[]) =>
  auditions.reduce((latest, audition) => Math.max(latest, parseTimestamp(audition.created_at)), 0);

export const getUnseenOpenAuditionsCount = (auditions: OpenAuditionListItem[]) => {
  const lastViewedAt = getOpenAuditionsLastViewedAt();
  return auditions.filter((audition) => parseTimestamp(audition.created_at) > lastViewedAt).length;
};

export const markOpenAuditionsViewed = (auditions: OpenAuditionListItem[]) => {
  if (typeof window === 'undefined') return;
  try {
    const latestTimestamp = getLatestOpenAuditionTimestamp(auditions);
    const viewedAt = latestTimestamp > 0 ? new Date(latestTimestamp).toISOString() : new Date().toISOString();
    localStorage.setItem(OPEN_AUDITIONS_LAST_VIEWED_KEY, viewedAt);
    window.dispatchEvent(new CustomEvent(OPEN_AUDITIONS_VIEWED_EVENT));
  } catch {
    // ignore storage errors
  }
};

export const subscribeToOpenAuditionsViewed = (listener: () => void) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  window.addEventListener(OPEN_AUDITIONS_VIEWED_EVENT, listener);
  return () => window.removeEventListener(OPEN_AUDITIONS_VIEWED_EVENT, listener);
};
